import React, { useEffect, useRef, useState } from "react";
// import "StickyImageSection.css"; // Assuming you have a CSS file for styles

interface SectionData {
  step: string;
  title: string;
  description: string;
  image: string;
}

const sections: SectionData[] = [
  {
    step: "Step 1",
    title: "Tracking setup takes 2 minutes",
    description: "Get started with a quick and simple setup that integrates seamlessly with your existing tech stack.",
    image: "https://liftoff.io/wp-content/uploads/2022/11/Vungle-exchange-homepage-content-block.svg",
  },
  {
    step: "Step 2",
    title: "Real-time insights",
    description: "See how your campaigns perform instantly with actionable metrics and no delays.",
    image: "https://liftoff.io/wp-content/uploads/2022/11/Liftoff-monetize-home-page-1.svg",
  },
  {
    step: "Step 3",
    title: "Conversion optimization",
    description: "Automatically refine your campaigns for better results and reduced ad spend.",
    image: "https://liftoff.io/wp-content/uploads/2022/10/v2.png",
  },
  {
    step: "Step 4",
    title: "Boosted ROI with AI",
    description: "Leverage machine learning to identify winning patterns and scale your performance.",
    image: "https://liftoff.io/wp-content/uploads/2022/11/Creative-studio-home-page-content-block-2.svg",
  },
];

const StickyImageScroll: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target instanceof HTMLElement) {
            const index = parseInt(entry.target.dataset.index || "0");
            setActiveIndex(index);
          }
        });
      },
      { threshold: 0.6 }
    );

    sectionRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="white-wrapper">
      <div className="text-sections">
        {sections.map((section, index) => (
          <div
            key={index}
            className="text-section"
            data-index={index}
            ref={(el) => (sectionRefs.current[index] = el)}
          >
            <p className="step">{section.step}</p>
            <h2 className="title">{section.title}</h2>
            <p className="description">{section.description}</p>
          </div>
        ))}
      </div>

      <div className="sticky-image-container">
        {sections.map((section, index) => (
          <img
            key={index}
            src={section.image}
            alt={`Image ${index}`}
            className={`sticky-image ${index === activeIndex ? "visible" : ""}`}
          />
        ))}
      </div>
    </div>
  );
};

export default StickyImageScroll;
